import React from 'react';
import FeaturesContainer from './FeaturesContainer';

const HubFeatures = props => <FeaturesContainer {...props} source="hub" />;

export default HubFeatures;
